require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-nicola-navone-jenseits-der-tessiner-schule-das-snf-forschungsprojekt-larchitettura-nel-cantone-ticino-1945-1980-mendrisio-24-marzo-2017.json") })
        }
      }, "path---en-relazioni-e-conferenze-nicola-navone-jenseits-der-tessiner-schule-das-snf-forschungsprojekt-larchitettura-nel-cantone-ticino-1945-1980-mendrisio-24-marzo-2017");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-nicola-navone-jenseits-der-tessiner-schule-das-snf-forschungsprojekt-larchitettura-nel-cantone-ticino-1945-1980-mendrisio-24-marzo-2017!./.cache/json/en-relazioni-e-conferenze-nicola-navone-jenseits-der-tessiner-schule-das-snf-forschungsprojekt-larchitettura-nel-cantone-ticino-1945-1980-mendrisio-24-marzo-2017.json
// module id = 639
// module chunks = 231608221292675